import {environment} from "../../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const JobApiResources = {
  list:  createUrl('jobs'),
  search:  createUrl('jobs/search'),
  create:  createUrl('jobs/create'),
  assingJob:  createUrl('jobs/assign/people'),
  assingPeople:createUrl('jobs/assign/people'),
  removeFromJob:  createUrl('jobs/remove/people'),
  statusList:  createUrl('jobs/statuses'),
  taskTypeList:  createUrl('task-types'),
  changeStatus:  createUrl('jobs/change/status'),
  detail:  createUrl('jobs'),
  update:  createUrl('jobs'),
  delete:  createUrl('jobs'),
  deleteMultiple:  createUrl('jobs/delete/multiple'),
  deleteAvailability:  createUrl('jobs/delete/availability'),
  updateUnionOptions:createUrl('jobs/update-union-options'),
  updateDepositStatus:createUrl('jobs/update/deposit/status'),
  costDrillDown:createUrl('jobs/cost-drill-down'),
  updatePurchaseOrder:createUrl('jobs/scope/update/purchase/order/date'),
  assignJobRole: createUrl('jobs/add/staff/job/role'),
  lineItems: createUrl('jobs'), // Will be used as jobs/{id}/line-items
  getScopes: createUrl('jobs/get-scopes'), // Will be used as jobs/get-scopes/{id}
  getMaterials: createUrl('jobs'), // Will be used as jobs/{id}/material
  updateSiteInfo: createUrl('jobs/site-info'),
  getJobsiteRequirements: createUrl('jobsite/requirements'),
  getJobsiteAccesses: createUrl('jobsites/accesses'),
  createJobsiteAccess: createUrl('jobsites/accesses'),
  getJobsiteParking: createUrl('jobsites/parking'),
  createJobsiteParking: createUrl('jobsites/parking'),
  createJobsite: createUrl('jobs/jobsite'),
  getJobsites: createUrl('jobs/{job_id}/jobsites'),
  cancelAndRebid: createUrl('jobs'), // Used as jobs/{id}/cancel-rebid
  undoCancelAndRebid: createUrl('jobs'), // Used as jobs/{id}/undo-cancel-rebid
  cancelJobSimple: createUrl('jobs'), // Used as jobs/{id}/cancel-simple
  cancelJobLostProposal: createUrl('jobs'), // Used as jobs/{id}/cancel-lost-proposal
};
